/* global FormData */
import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import ErrorMessage from 'components/ErrorMessage'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'
import { AiFillCamera } from 'react-icons/ai'
import OImage from 'components/reusable/OImage'
import OButton from 'components/reusable/OButton'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import useToastContext from 'hooks/useToastContext'
const AdsEdit = ({ bannerData, setEditModal, getAllBanners }) => {
  const [profilePicError, setProfilePicError] = useState('')
  const profilePicRef = useRef()
  const { t } = useTranslation()
  const notification = useToastContext()
  const [bannerDataLocal, setBannerData] = useState(bannerData)

  const handleDataChange = ({ target }) => {
    if (target.name === 'bannerImage' && !validateFiles(target.files[0])) return
    if (target.name === 'bannerImage') {
      setBannerData(prev => ({ ...prev, [target.name]: target.files[0] }))
    } else {
      setBannerData(prev => ({ ...prev, [target.name]: target.value }))
    }
  }
  const {
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    shouldFocusError: true
  })

  const validateFiles = bannerImage => {
    let picError = ''
    const supportedTypes = ['image/jpeg', 'image/jpg', 'image/png']

    if (!isEmpty(supportedTypes.includes(bannerImage.type))) {
      picError = 'Only jpeg, jpg and png are supported.'
    }

    if (picError) {
      setProfilePicError(picError)
      return false
    } else {
      setProfilePicError('')
      return true
    }
  }
  const onSubmit = async data => {
    try {
      const formData = new FormData()
      formData.append('description', bannerDataLocal.description)
      formData.append('descriptionAr', bannerDataLocal.descriptionAr)
      formData.append('bannerType', bannerDataLocal.bannerType)
      formData.append('bannerImage', bannerDataLocal.bannerImage)

      const path = apiPath.editBanner + '/' + bannerData._id

      const result = await apiPut(path, formData)
      if (result?.data?.success) {
        setEditModal(false)
        getAllBanners()
        notification.success(result.data.message)
      } else {
        notification.error(result.data.message)
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  return (
    <div>
      <>
        <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
          <div className='relative my-6  w-full max-w-[1150px] mx-auto'>
            <div className='sm:py-4 sm:px-2 py-8 px-7 '>
              <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
                <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                  <h3 className='text-xl font-semibold'>
                    {t('O_Edit_BANNER')}
                  </h3>
                  <button
                    className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                    onClick={() => setEditModal(false)}
                  >
                    <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                      ×
                    </span>
                  </button>
                </div>
                <form onSubmit={onSubmit} method='post'>
                  <div className='relative p-6 flex-auto'>
                    <div className='grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
                      <div>
                        <div className='py-4 flex justify-center'>
                          <div className='relative'>
                            <label className='block mb-2 text-sm font-medium text-gray-900 dark:text-white w-30'>
                              {!bannerDataLocal?.bannerImage
                                ? (<span className='flex align-center' onClick={() => profilePicRef?.current?.click()}> {t('BANNER_UPLOAD')} <AiFillCamera /> </span>)
                                : (<span className='flex align-center'> {t('BANNER_UPLOAD')}</span>)}
                            </label>
                            <input
                              type='file'
                              accept='image/png, image/jpg, image/jpeg'
                              name='bannerImage'
                              ref={profilePicRef}
                              onChange={handleDataChange}
                              className='hidden'
                            />

                            <div className='relative'>
                              {bannerDataLocal?.bannerImage && (
                                <OImage
                                  src={
                                    typeof bannerDataLocal?.bannerImage ===
                                    'object'
                                      ? URL.createObjectURL(bannerDataLocal?.bannerImage)
                                      : bannerDataLocal?.bannerImage
                                  }
                                  fallbackUrl='/images/user.png'
                                  className='w-24 h-24 m-auto'
                                  alt=''
                                  style={{ borderRadius: '50%' }}
                                />
                              )}

                              {bannerDataLocal?.bannerImage && (
                                <AiFillCamera
                                  className=' bg-gray-100  absolute w-4 rounded-xl cursor-pointer '
                                  style={{
                                    width: '1.5rem',
                                    height: '1.5rem',
                                    bottom: '0',
                                    right: '20px',
                                    background: '',
                                    padding: '1px'
                                  }}
                                  onClick={() => profilePicRef?.current?.click()}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='text-center mt-4'>
                          <ErrorMessage message={profilePicError} />
                        </div>
                      </div>
                      <div className='px-2'>
                        <div className='relative z-0 mb-6 w-full group'>
                          <select
                            name='bannerType'
                            id='bannerType'
                            value={bannerDataLocal?.bannerType}
                            onChange={handleDataChange}
                            className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                            placeholder=' '
                          >
                            <option value=''>{t('SELECT_BANNER_TYPE')}</option>
                            <option value='sales'>{t('SALES')}</option>
                            <option value='promotional'>{t('PROMOTIONAL')}</option>
                          </select>
                          <label
                            for='bannerType'
                            className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                          >
                            {t('O_BANNER_TYPE')}
                          </label>

                          <ErrorMessage message={errors?.bannerType?.message} />
                        </div>
                      </div>
                      <div className='px-2'>
                        <div className='relative z-0 mb-6 w-full group'>
                          <textarea
                            name='description'
                            value={bannerDataLocal.description}
                            onChange={handleDataChange}
                            id='description'
                            placeholder=' '
                            className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer'
                          />
                          <label
                            htmlFor='address'
                            className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                          >
                            {t('O_BANNER_DESCRIPTION')}
                          </label>
                          <ErrorMessage
                            message={errors?.description?.message}
                          />
                        </div>
                      </div>
                      <div className='px-2'>
                        <div className='relative z-0 mb-6 w-full group'>
                          <textarea
                            name='descriptionAr'
                            value={bannerDataLocal?.descriptionAr}
                            onChange={handleDataChange}
                            id='descriptionAr'
                            placeholder=' '
                            className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer'
                          />
                          <label
                            htmlFor='address'
                            className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                          >
                            {t('O_BANNER_DESCRIPTION') + t('O_ARABIC')}
                          </label>
                          <ErrorMessage
                            message={errors?.descriptionAr?.message}
                          />
                        </div>
                      </div>
                    </div>
                    <OButton
                      label={<>{t('O_EDIT')} </>}
                      type='button'
                      onClick={onSubmit}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className='opacity-25 fixed inset-0 z-40 bg-black' />
      </>
    </div>
  )
}

export default AdsEdit
